import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {Tooltip} from "antd";
import {
    DeleteOutlined,
    FileAddOutlined,
    FileExcelOutlined,
    HomeOutlined,
    LogoutOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    PlusOutlined, ProductFilled, ProductOutlined,
    SettingOutlined, UserOutlined,
} from "@ant-design/icons";
import {GiGamepadCross} from "react-icons/gi";
import {BiCross, BiLogoProductHunt} from "react-icons/bi";
import {CgCross} from "react-icons/cg";
import {MdOutlineProductionQuantityLimits} from "react-icons/md";
import {GrDocumentMissing} from "react-icons/gr";

const Sidebar = ({setCollapsed, collapsed}) => {
        const navigate = useNavigate();
        const location = useLocation();

        const menuItems = [
            {text: "Home", icon: <HomeOutlined/>, path: "/HomePage"},
            {text: "Add Product", icon: <PlusOutlined/>, path: "/Product"},
            {text: "Upload CSV", icon: <FileAddOutlined/>, path: "/Upload"},
            {text: "Manage Products", icon: <ProductFilled/>, path: "/Manage"},
            {text: "Update Products", icon: <ProductFilled/>, path: "/Update"},
            {text: "Upload Products", icon: <ProductOutlined/>, path: "/UploadProducts"},
            // {text: "Missing Products", icon: <GrDocumentMissing/>, path: "/Missing"},
            {text: "Manage Users", icon: <UserOutlined/>, path: "/Users"},
            {text: "Setting", icon: <SettingOutlined/>, path: "/Setting"},
            {text: "Log Out", icon: <LogoutOutlined/>, path: "#"}, // Logout
            {
                text: "Collapse",
                icon: collapsed ? <MenuUnfoldOutlined/> : <MenuFoldOutlined/>,
                path: "#",
            },
        ];

        const handleLogout = () => {
            localStorage.removeItem("accessToken");
            navigate("/"); // Redirect to home or login page after logout
        };

        const handleClick = (path, text) => {
            if (text === "Log Out") {
                handleLogout(); // Logout logic
            } else if (text === "Collapse") {
                handleCollapseClick();
            } else {
                navigate(path);
            }
        };

        const handleCollapseClick = () => {
            setCollapsed(!collapsed); // Toggle collapse state in the parent component
        };

        const getSelected = (path) => (location.pathname === path ? "bg-[#4db6ff]" : "");

        const getIconColor = (path) => (location.pathname === path ? "white" : "#000000");

        return (
            <div className={`pt-24 h-screen w-full bg-[#2a6499] px-2 transition-all duration-300`}>
                <div className={`cursor-pointer ${collapsed ? "flex items-center justify-center" : ""}`}>
                    {/* Optional: Place the logo or any additional content here */}
                </div>
                <div className={`flex flex-col gap-4 mt-10 ${collapsed ? "items-center" : ""}`}>
                    {menuItems.slice(0, 5).map((item, index) => (
                        <Tooltip
                            title={collapsed ? item.text : ""}
                            key={index}
                            placement="right"
                            color="#2a6499"
                        >
                            <div
                                onClick={() => handleClick(item.path, item.text)}
                                className={`px-3 py-3 flex items-center gap-3 cursor-pointer ${getSelected(
                                    item.path
                                )} ${collapsed ? "justify-center rounded-full" : "rounded-xl"}`}
                            >
                                <div style={{color: getIconColor(item.path), fontSize: "24px"}}>
                                    {item.icon}
                                </div>
                                {!collapsed && (
                                    <p className="text-lg text-white">{item.text}</p>
                                )}
                            </div>
                        </Tooltip>
                    ))}
                </div>
                <div className="w-full h-[1px] my-2 bg-white opacity-20"></div>
                <div className={`flex flex-col gap-4 ${collapsed ? "items-center" : ""}`}>
                    {menuItems.slice(5).map((item, index) => (
                        <Tooltip
                            title={collapsed ? item.text : ""}
                            key={index}
                            placement="right"
                            color="#2a6499"
                        >
                            <div
                                onClick={() => handleClick(item.path, item.text)}
                                className={`px-3 py-3 flex items-center gap-3 cursor-pointer ${getSelected(
                                    item.path
                                )} ${collapsed ? "justify-center rounded-full" : "rounded-xl"}`}
                            >
                                <div style={{color: getIconColor(item.path), fontSize: "24px"}}>
                                    {item.icon}
                                </div>
                                {!collapsed && (
                                    <p className="text-lg text-white">{item.text}</p>
                                )}
                            </div>
                        </Tooltip>
                    ))}
                </div>
            </div>
        );
    }
;

export default Sidebar;
